import type { PaypalConfig } from '#types/config/components/paypal'
import type { RecursivePartial } from '#types/utils'

export default {
  style: {
    layout: 'text',
    logo: {
      type: 'inline'
    },
    text: {
      color: 'monochrome'
    }
  },
  showAmount: {
    product: false,
    cart: true,
    payment: true
  }
} satisfies RecursivePartial<PaypalConfig['payments']>
